import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Frm } from '../../components/frm/frm.interface';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { OrgaoJulgador } from '../../orgao-julgador/orgao-julgador.model';
import { OrgaoJulgadorService } from '../../orgao-julgador/orgao-julgador.service';
import { SelectItemService } from '../../services/select-item.service';
import { OrgaoJulgadorLocal } from '../orgao-julgador-local.model';
import { OrgaoJulgadorLocalService } from '../orgao-julgador-local.service';
import { OrgaoJustica } from '../../orgao-justica/orgao-justica.model';
import { OrgaoJusticaService } from '../../orgao-justica/orgao-justica.service';
import { SelectItem } from 'primeng/api';
import { OrgaoService } from '../../orgao/orgao.service';

@Component({
  selector: 'app-orgao-julgador-local-frm',
  templateUrl: './orgao-julgador-local-frm.component.html',
  styleUrls: ['./orgao-julgador-local-frm.component.css'],
})
export class OrgaoJulgadorLocalFrmComponent implements OnInit, Frm<OrgaoJulgadorLocal, number> {
  public orgaoJulgadorSugestoes: OrgaoJulgador[];
  public orgaoJusticaItens: OrgaoJustica[];
  public booleanoSimNaoItens: SelectItem[];

  @Output()
  public onSalvar = new EventEmitter<void>();

  entidade: OrgaoJulgadorLocal;
  isInsercao: boolean;
  isOrgaoJusticaBloqueado = true;
  isOrgaoJulgadorBloqueado = true;
  orgaoJustica: OrgaoJustica;

  constructor(
    private service: OrgaoJulgadorLocalService,
    private mensagemService: MensagemService,
    public orgaoJusticaService: OrgaoJusticaService,
    private progressoService: ProgressoService,
    public orgaoJulgadorService: OrgaoJulgadorService,
    private selectItemService: SelectItemService,
    private orgaoService: OrgaoService
  ) {}

  ngOnInit(): void {
    this.entidade = {} as OrgaoJulgadorLocal;
    this.booleanoSimNaoItens = this.selectItemService.getBooleanoSimNaoItens();

    this.orgaoJusticaService
      .recuperarItens()
      .then((orgaoJustica) => {
        this.orgaoJusticaItens = orgaoJustica;
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro', 'Erro ao encontrar orgãos justiça: ' + resposta.message);
      });
  }

  public onCompleteOrgaoJulgador(termo: string) {
    this.progressoService.modeless();
    if (this.orgaoJustica === null || this.orgaoJustica.id === null) {
      this.mensagemService.addAlerta('Atenção', 'Selecione o Orgão de Justiça para carregar as sugestões de Órgãos Julgadores');
    } else {
      this.orgaoService
        .recuperarSugestoesPorOrgaoId(this.orgaoJustica ? this.orgaoJustica.id : null, termo)
        .then((sugestoes) => {
          this.progressoService.fechar();
          this.orgaoJulgadorSugestoes = sugestoes.map(
            (o) => ({ id: o.id, nome: o.descricao, situacao: o.situacao, orgao: o } as OrgaoJulgador)
          );
        })
        .catch((resposta) => {
          this.progressoService.fechar();
          this.mensagemService.addErro('Erro ao carregar as sugestões de Órgãos Julgadores!', resposta.error);
        });
    }
  }

  salvar(): void {
    this.progressoService.modal();
    this.service
      .alterar(this.entidade)
      .then((parametro) => {
        this.entidade = parametro;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'O orgão julgador local foi salvo com sucesso');
        this.onSalvar.emit();
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar o orgão julgador local', resposta.error);
        this.progressoService.fechar();
      });
  }

  iniciarInsercao(): void {
    this.isInsercao = true;
  }

  iniciarAlteracao(entidade: OrgaoJulgadorLocal): void {
    this.isInsercao = false;
    this.entidade = entidade;
    this.selecaoOrgaoJustica();
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();

    this.service
      .recuperarPorId(id)
      .then((parametro) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(parametro);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o orgão julgador local para edição', resposta.error);
      });
  }

  selecaoOrgaoJustica(): void {
    if (this.entidade.fonteDados.extrator.orgaoJustica === undefined || this.entidade.fonteDados.extrator.orgaoJustica === null) {
      this.isOrgaoJusticaBloqueado = false;

      if (this.entidade.orgaoJulgador.id !== -1) {
        this.orgaoJustica = this.entidade.orgaoJulgador.orgaoJustica;
        this.isOrgaoJulgadorBloqueado = false;
      } else if (this.entidade.orgaoJulgador.id === -1) {
        this.orgaoJustica = undefined;
        this.isOrgaoJulgadorBloqueado = true;
      }
    } else if (
      this.entidade.fonteDados.extrator.orgaoJustica !== undefined ||
      this.entidade.fonteDados.extrator.orgaoJustica !== null
    ) {
      if (this.entidade.orgaoJulgador.id !== -1) {
        this.orgaoJustica = this.entidade.orgaoJulgador.orgaoJustica;
        this.isOrgaoJulgadorBloqueado = false;
      } else if (this.entidade.orgaoJulgador.id === -1) {
        this.orgaoJustica = this.entidade.fonteDados.extrator.orgaoJustica;
        this.isOrgaoJulgadorBloqueado = false;
      }
    }
  }

  sincronizar(orgaoJusticaId: number): void {
    this.progressoService.modal();
    this.orgaoJulgadorService
      .sincronizarPorOrgaoJusticaId(orgaoJusticaId)
      .then(() => {
        this.mensagemService.addSucesso('Resultado', 'Sincronização concluída com sucesso');
        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.mensagemService.addErro(
          `Erro ao recuperar sincronizar os orgão julgadores do órgão de justiça ID: ${orgaoJusticaId} `,
          resposta.error
        );
        this.progressoService.fechar();
      });
  }
}
